import { coreUrls } from '@/api/urls/core';

import { formatStringByKey } from '@/utilities/formatStringByKey';
import { setApiOptions, setPaymentApiOptions } from '@/utilities/services';

import { addBatteryOrderDescriptionBodyParam, ListResponse, RequestResponseType } from '../../../../models';

import { api } from '@/api/client';
import {
    BatteryOrderType,
    GetBatteryOrdersQueryParamType,
    setBatteryOrderAddressBodyParam,
    setBatteryOrderAncillaryBodyParam,
    SetBatteryOrderBodyParam,
    setBatteryOrderPaymentQueryParam,
    setBatteryOrderTimeSlotBodyParam
} from '@/client/services/core/batteryOrder/models';
import { AxiosPromise } from 'axios';

export const getBatteryOrdersService = (queryParam: GetBatteryOrdersQueryParamType): AxiosPromise<ListResponse<BatteryOrderType>> => {
    const options = setApiOptions(coreUrls.getBatteryOrders, { queryParam });
    return api({ ...options, method: 'GET' });
};

export const getBatteryOrderByUuidService = ({
    uuid,
    isInstalment = false,
    payByWallet = false,
    gatewayId
}: {
    uuid: string;
    isInstalment?: boolean;
    payByWallet?: boolean;
    gatewayId?: number;
}): AxiosPromise<RequestResponseType<BatteryOrderType>> => {
    const options = setApiOptions(formatStringByKey(coreUrls.getBatteryOrderByUuid, { uuid }), {
        queryParam: { isInstalment, payByWallet, gatewayId }
    });
    return api({ ...options, method: 'GET' });
};

export const setBatteryOrderService = (bodyParam: SetBatteryOrderBodyParam): AxiosPromise<RequestResponseType<BatteryOrderType>> => {
    const options = setApiOptions(coreUrls.setBatteryOrder, { bodyParam });
    return api({ ...options, method: 'POST' }, true);
};

export const setBatteryOrderTimeSlotService = (
    bodyParam: setBatteryOrderTimeSlotBodyParam,
    uuid: string
): AxiosPromise<RequestResponseType<BatteryOrderType>> => {
    const options = setApiOptions(formatStringByKey(coreUrls.setBatteryOrderTimeSlot, { uuid }), { bodyParam });
    return api({ ...options, method: 'PATCH' });
};

export const setBatteryOrderAddressService = (
    bodyParam: setBatteryOrderAddressBodyParam,
    uuid: string
): AxiosPromise<RequestResponseType<BatteryOrderType>> => {
    const options = setApiOptions(formatStringByKey(coreUrls.setBatteryOrderAddress, { uuid }), { bodyParam });
    return api({ ...options, method: 'PATCH' });
};

export const setBatteryOrderAncillaryService = (
    bodyParam: setBatteryOrderAncillaryBodyParam,
    uuid: string
): AxiosPromise<RequestResponseType<BatteryOrderType>> => {
    const options = setApiOptions(formatStringByKey(coreUrls.setBatteryOrderAncillary, { uuid }), { bodyParam });
    return api({ ...options, method: 'PATCH' });
};

export const setBatteryOrderPaymentService = (
    uuid: string,
    queryParam: setBatteryOrderPaymentQueryParam
): AxiosPromise<RequestResponseType<string>> => {
    const options = setPaymentApiOptions(formatStringByKey(coreUrls.setBatteryOrderPayment, { uuid }), { queryParam });
    return api({ ...options, method: 'POST' });
};

export const setBatteryOrderExtraAmountPaymentService = (
    uuid: string,
    queryParam: setBatteryOrderPaymentQueryParam
): AxiosPromise<RequestResponseType<string>> => {
    const options = setPaymentApiOptions(formatStringByKey(coreUrls.setBatteryOrderExtraAmountPayment, { uuid }), { queryParam });
    return api({ ...options, method: 'POST' });
};

export const setBatteryOrderCouponService = (
    uuid: string,
    couponCode: string,
    isInstalment: boolean,
    gatewayId: number
): AxiosPromise<RequestResponseType<BatteryOrderType>> => {
    const options = setApiOptions(formatStringByKey(coreUrls.setBatteryOrderCoupon, { uuid, couponCode }), {
        queryParam: { isInstalment, gatewayId }
    });
    return api({ ...options, method: 'POST' });
};

export const deleteBatteryOrderCouponService = (uuid: string): AxiosPromise<RequestResponseType<any>> => {
    const options = setApiOptions(formatStringByKey(coreUrls.deleteBatteryOrderCoupon, { uuid }));
    return api({ ...options, method: 'DELETE' });
};

export const addBatteryOrderDescriptionService = (uuid: string, bodyParam: addBatteryOrderDescriptionBodyParam) => {
    const options = setApiOptions(formatStringByKey(coreUrls.addBatteryOrderDescription, { uuid }), { bodyParam });
    return api({ ...options, method: 'PATCH' });
};
